/**
 * @files 路由入口文件
 */

import NestedRoute from '@/components/NestedRoute/index.vue'
import { DynamicImportReturnType } from './types'

import { paymentRoutes } from './payment'

export default [
  {
    path: '/entry',
    name: 'Entry',
    component: NestedRoute,
    children: [
      {
        path: 'tuitionCode',
        name: 'TuitionCodeEntry',
        component: (): DynamicImportReturnType =>
          import('@/pages/Entry/TuitionCode/index.vue'),
        meta: {
          title: '支付学费',
        },
      },
      {
        path: 'thirdParty',
        name: 'ThirdParty',
        component: (): DynamicImportReturnType =>
          import('@/pages/Entry/ThirdParty/index.vue'),
        meta: {
          title: '支付学费',
        },
      },
    ],
  },
  {
    path: '/selectPaymentMethod',
    name: 'SelectPaymentMethod',
    component: (): DynamicImportReturnType =>
      import('@/pages/SelectPaymentMethod/index.vue'),
    meta: {
      title: '选择支付方式',
    },
  },
  paymentRoutes,
  {
    path: '/latestPaymentRecords',
    name: 'LatestPaymentRecords',
    component: (): DynamicImportReturnType =>
      import('@/pages/LatestPaymentRecords/index.vue'),
    meta: {
      title: '最近30天交易记录',
    },
  },
  {
    path: '/paymentResult',
    name: 'PaymentResult',
    component: (): DynamicImportReturnType =>
      import('@/pages/PaymentResult/index.vue'),
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/goldPlanPaymentResult',
    name: 'GoldPlanPaymentResult',
    component: (): DynamicImportReturnType =>
      import('@/pages/GoldPlanPaymentResult/index.vue'),
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/paymentLoadingPage',
    name: 'PaymentLoadingPage',
    component: (): DynamicImportReturnType =>
      import('@/pages/payment/paymentLoadingPage/index.vue'),
    meta: {
      title: '校宝收银宝',
    },
  },
  {
    path: '/common/error',
    name: 'CommonError',
    component: (): DynamicImportReturnType =>
      import('@/pages/Common/Error/index.tsx'),
    meta: {
      title: '遇到了一些问题',
    },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: (): DynamicImportReturnType => import('@/pages/NotFound/index'),
    meta: {
      title: '无法找到请求的页面',
    },
  },
  {
    path: '*',
    redirect: '/404',
  },
]
